import {
    Box,
    Grid2,
} from '@mui/material'
import React, { useEffect } from 'react'
import CourseCard from '../../shared/components/CourseCard'
import { CustomIconButton } from '../../shared/utils/CustomIcon'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomDivider from '../../shared/utils/CustomDivider';
import HorizontalScroll from '../../shared/components/HorizontalScroll';
import { useNavigate } from 'react-router-dom';
import { NavigateButton } from '../../shared/utils/CustomButton';
import { useCourses } from '../../assets/api/useGetApi';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';

export const NavigationArrows = ({ leftHandleClick, rightHandleClick }) => {
    return <Box sx={{ display: 'flex', gap: 2 }}>
        <CustomIconButton icon={<ArrowBackIcon sx={{ color: "red.main", fontSize: "20px" }} />} bgcolor={"red.light"} onClick={leftHandleClick} />
        <CustomIconButton icon={<ArrowForwardIcon sx={{ color: "primary.main", fontSize: "20px" }} />} bgcolor={"red.main"} onClick={rightHandleClick} />
    </Box>
}

const LatestCourses = ({ itemcount }) => {
    const navigate = useNavigate()
    const { data, fetchNextPage, hasNextPage, isLoading } = useCourses();
    useEffect(() => {
      if (hasNextPage) {
        fetchNextPage();
      }
    }, [hasNextPage, fetchNextPage]);
    const courses = data?.pages.flatMap(page => page.data) || [];
    return (
        <Box>
            <HorizontalScroll heading={"Latest Courses at MySkill!"} subheading={"Discover our newest courses!"} size={3}>
                
                {!isLoading && (
                   courses?.map((item, index) => (
                        <Grid2 children key={index} size={{xs:12, sm:5.7 ,lg:3.7}} sx={{  flex: "0 0 auto" , display:"flex" , alignItems:"stretch"}}>
                         <CourseCard item={item} />
                         
                        </Grid2>
                    ))
                )}
                {
                    isLoading && [...Array(6)].map((_, index) => (
                        <Grid2 children key={index} size={{xs:12, sm:5.7 ,lg:3.7}} sx={{flex: "0 0 auto" }}>
                            <SkeletonCom />
                        </Grid2>
                    ))
                }
            </HorizontalScroll>
            <CustomDivider orientation='horizontal' size={"30px"} />
            <NavigateButton onClick={() => navigate('/Courses')} />
        </Box>

    )
}

export default LatestCourses